/**
 * djb2 hash — deterministic 32-bit string hash.
 * Returns an unsigned hex string.
 */
function djb2(str) {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash) + str.charCodeAt(i);
  }
  return (hash >>> 0).toString(16);
}

/**
 * Generate a deterministic hash of all fields sent to the Gemini analysis prompt.
 * Must stay in sync with the prompt template in geminiService.js analyzePropertyDescription().
 */
export const generateAnalysisHash = (property) => {
  const input = {
    price: property.price || property.lastKnownPrice || 0,
    area: property.area || '',
    bedrooms: property.bedrooms || '',
    bathrooms: property.bathrooms || '',
    title: property.apiTitle || property.title || '',
    notes: property.notes || '',
    url: property.url || '',
    year: new Date().getFullYear(),
  };
  const jsonString = JSON.stringify(input);
  return { hash: djb2(jsonString), inputLength: jsonString.length };
};

/**
 * Generate a deterministic hash of all fields sent to the Gemini comparison prompt.
 * Must stay in sync with the prompt template in geminiService.js compareProperties().
 *
 * cityId is intentionally excluded — its effect is captured through similarityScore
 * (awarded by findSimilarProperties). Including it separately would cause false
 * invalidations when cityId changes without affecting the score.
 */
export const generateComparisonHash = (targetProperty, similarProperties) => {
  const target = {
    price: targetProperty.price || targetProperty.lastKnownPrice || 0,
    area: targetProperty.area || '',
    bedrooms: targetProperty.bedrooms || '',
    bathrooms: targetProperty.bathrooms || '',
    title: targetProperty.apiTitle || targetProperty.title || '',
  };

  const similar = [...similarProperties]
    .sort((a, b) => (a.id > b.id ? 1 : a.id < b.id ? -1 : 0))
    .map((p) => ({
      id: p.id,
      price: p.price || p.lastKnownPrice || 0,
      area: p.area || '',
      bedrooms: p.bedrooms || '',
      bathrooms: p.bathrooms || '',
      title: p.apiTitle || p.title || '',
      similarityScore: p.similarityScore,
    }));

  const input = { target, similar, year: new Date().getFullYear() };
  const jsonString = JSON.stringify(input);
  return { hash: djb2(jsonString), inputLength: jsonString.length };
};
